<template>
  <div class="skeleton-text">
    <v-skeleton-loader
      :loading="loading"
      :max-width="maxWidth"
      type="paragraph">
      <slot />
    </v-skeleton-loader>
  </div>
</template>

<script>
export default {
  name: 'SkeletonText',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    maxWidth: {
      type: String,
      default: "700"
    }
  }
}
</script>

<style lang="scss" scoped>
.skeleton-text {
  width: 100%;

  .v-skeleton-loader {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>